import ProductGridIsland from "~/islands/page/ProductGridIsland.svelte";
import { createIslandEntrypoint } from "~/lib/islands/create-island-entrypoint";

createIslandEntrypoint(ProductGridIsland, "plp", ".da-listing-skeleton-grid");
